import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { adminApi } from '../services/adminApi';
import { authApi } from '../services/authApi';
import { documentsApi } from '../services/documentsApi';
import { historyApi } from '../services/historyApi';
import { persistReducer, persistStore } from 'redux-persist';
import appSlice from './slices/appSlice';
import authReducer from '../redux/slices/authSlice';
import storage from 'redux-persist/lib/storage';

const persistedAuthReducer = persistReducer({ key: 'root', storage }, authReducer);

export const store = configureStore({
    reducer: {
        [authApi.reducerPath]: authApi.reducer,
        [documentsApi.reducerPath]: documentsApi.reducer,
        [historyApi.reducerPath]: historyApi.reducer,
        auth: persistedAuthReducer,
        alert: appSlice,
        admin: adminApi.reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        })
            .concat(authApi.middleware)
            .concat(documentsApi.middleware)
            .concat(historyApi.middleware)
            .concat(adminApi.middleware)
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
